import $ from "jquery";

$(document).ready(function() {
    var $round = $('.round').map(function() {
        var roundRadius = $(this).find('.main-circle').attr('r');
        var roundPercent = $(this).data("percent");
        var roundCircum = 2 * roundRadius * Math.PI;
        var roundDraw = roundPercent * roundCircum / 100;

        var cx = $(this).find('.main-circle').attr('cx');
        var cy = $(this).find('.main-circle').attr('cy');

        var angle = (roundDraw / roundRadius) % (2 * Math.PI);
        var endX = parseFloat(cx) + roundRadius * Math.cos(angle);
        var endY = parseFloat(cy) + roundRadius * Math.sin(angle);

        $(this).find('.last-circle').attr('cx', endX);
        $(this).find('.last-circle').attr('cy', endY);

        $(this).css('stroke-dasharray', roundDraw + ' 999');
    })
})